import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetGroupQuery } from '@/services/sibling-group-api';
import Page from '@/components/page';
import PageTitle from '@/components/page-title';
import Siblings from './siblings';
import GroupBio from './group-bio';

const ViewSiblingGroup = ({ updateSignal }) => {
  const navigate = useNavigate();
  const { groupId } = useParams();
  const { data, isLoading, refetch } = useGetGroupQuery({ groupId }, { skip: !groupId });

  useEffect(() => {
    refetch();
  }, [updateSignal, refetch]);

  useEffect(() => {
    if (groupId && !isLoading && !data) {
      navigate('/sibling-group');
    }
  }, [groupId, data, isLoading, navigate]);

  return (
    <Page
      breadcrumb={[
        { path: '/sibling-group', label: 'Sibling Group' },
        { path: `/sibling-group/${groupId}`, label: groupId },
        'View',
      ]}
      size="xl"
      loading={groupId && !data}
    >
      <PageTitle label="Sibling Group" />
      <Siblings groupId={groupId} />
      <GroupBio groupData={data} />
    </Page>
  );
};

export default ViewSiblingGroup;
